var path = 'src/app/forms/fields/drug-field.html';
var html = "<div drug-selector frm-model frm-required ng-model=model ng-required=required()></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/drug-field.html
 ** module id = 267
 ** module chunks = 0
 **/